// @flow
import * as React from 'react';
import styles from './styles';
import messages from '../messages';

type Props = {
  intl: Object,
  title: string,
  yourSearch: boolean,
  customStyles?: ?Object,
};

export default function SearchTitle({ intl, title, yourSearch, customStyles }: Props): React.Node {
  return (
    <React.Fragment>
      <div className="title">
        {yourSearch && `${intl.formatMessage(messages.yourSearch)}: `}
        <h1>{title}</h1>
      </div>
      <style jsx>{customStyles}</style>
    </React.Fragment>
  );
}

SearchTitle.defaultProps = {
  customStyles: styles,
};



// WEBPACK FOOTER //
// ./app/components/shared/Titles/SearchTitle/index.js